import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';

let apiUrl = 'http://localhost:9000/api/v1';

console.log(`env: ${process.env.NODE_ENV}`);
if (process.env.NODE_ENV === 'production') {
    apiUrl = process.env.REACT_APP_REST_URL + '/api/v1';
}

const httpClient = fetchUtils.fetchJson;

const pkMap = {
    firmwares: 'firmwareId',
    hydrant: 'deviceId',
    client: 'clientId',
    jobs: 'jobId',
    clients: 'clientId'
};

const resourcePaths = {
    "events": "events/all",
    "jobs": "firmwares/jobs",
}

const methods = {
    getList: async (resource, params) => {
        console.log(`url: ${apiUrl}`);
        console.log(`DataProvider.getList - ${resource}`);   
        const { page, perPage } = params.pagination;
        // let { field, order } = params.sort;
        // field = field === 'id' ? pkMap[resource] : field;
        console.log(params.filter);
        const resourcePath = Object.keys(resourcePaths).includes(resource) ? resourcePaths[resource] : resource;
        const query = {
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            filter: JSON.stringify(params.filter),
            // sort: JSON.stringify([field, order]),
            // sort: JSON.stringify(['firmwareId', 'ASC']),
        };
        console.log(query);
        const url = resource === "events" ? `${apiUrl}/${resourcePath}` : `${apiUrl}/${resourcePath}?${stringify(query)}`;
        
        console.log(`resource url: ${url}`);
        const token = localStorage.getItem('token');        
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`); 
        console.log(`headers: ${token}`);
        const result = await httpClient(url, {headers})
        const json = result.json;
        console.log(json);

        if (json instanceof Array) {
            if (resource === "clients") {
                json.forEach(obj => {
                    obj.id = obj.clientId;
                });
            }
            return {
                data: json,
                total: json.length,
            }
        }

        const jsonData = json.data;
        if (resource === "events") {
            jsonData.forEach(obj => {
                obj.id = obj.eventid;
            });
        }
        return {
            data: jsonData,
            total: json.count,
        }
    },

    getOne: (resource, params) =>
        httpClient(`${apiUrl}/${resource}/${params.id}`).then(({ json }) => ({
            data: json,
        })),

    getMany: (resource, params) => {
        console.log(`DataProvider.getMany - ${resource}`);
        
        const query = {
            filter: JSON.stringify({ [pkMap[resource]]: params.ids }),
        };

        const token = localStorage.getItem('token');        
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);     

        const url = `${apiUrl}/${resource}?${stringify(query)}`;
        return httpClient(url, {headers}).then(({ json }) => ({ data: json.data }));
    },

    getManyReference: (resource, params) => {
        console.log(`DataProvider.getManyReference - ${resource}`);

        const { page, perPage } = params.pagination;
        let { field, order } = params.sort;
        field = field === 'id' ? pkMap[resource] : field;        
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            filter: JSON.stringify({
                ...params.filter,
                [params.target]: params.id,
            }),
        };
        console.log(query);
        const url = `${apiUrl}/${resource}?${stringify(query)}`;

        return httpClient(url).then(({ headers, json }) => ({
            data: json,
            total: parseInt(headers.get('content-range').split('/').pop(), 10),
        }));
    },

    update: (resource, params) =>
        httpClient(`${apiUrl}/${resource}/${params.id}`, {
            method: 'PUT',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({ data: json })),

    updateMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids}),
        };
        return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
            method: 'PUT',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({ data: json }));
    },

    create: (resource, params) =>{
        console.log(`DataProvider.create - ${resource}`);
        console.log(params);
        const token = localStorage.getItem('token');        
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`); 

        if (resource === 'firmwares'){
            const file = params.data.files.rawFile;
            const fd = new FormData();
            fd.append('description', params.data.description || '');
            fd.append('file', file);
            return httpClient(`${apiUrl}/${resource}`, {
                method: 'POST',
                body: fd,
                headers
            }).then((json) => {
                console.log(JSON.stringify(json));
                return { data: { ...params.data, id: json.firmwareId } };
            });
        } else {
            const data = params.data;
            if (resource === "jobs") {
                data.deviceIds = data.deviceIds.toString().split(',');
                // data.deviceIds = JSON.parse("[" + data.deviceIds + "]");       
                // data.deviceIds = data.deviceIds.map( (i) => i.toString());
            }
            resource = resource === "jobs" ? "firmwares/jobs" : resource;
            return httpClient(`${apiUrl}/${resource}`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers,
            }).then(({ json }) => ({
                data: { ...params.data, id: json.id },
            }));
        }
        
    },

    delete: (resource, params) =>
        httpClient(`${apiUrl}/${resource}/${params.id}`, {
            method: 'DELETE',
        }).then(({ json }) => ({ data: json })),

    deleteMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids}),
        };
        return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
            method: 'DELETE',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({ data: json }));
    },
};

export default methods;
